import { Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Register from "./Components/Body/Register";
import Login from "./Components/Auth/Login";
import UserList from "./Pages/Admin/UserList";
import CompanyList from "./Pages/Admin/CompanyList";
import UserLogin from "./Components/Auth/UserLogin";
import UserDetailsForm from "./Components/Auth/UserDetailsForm";
import SetPassword from "./Components/Auth/SetPassword";
import UserProfile from "./Components/User/UserProfile";
import CompanyDetailsForm from "./Components/Auth/CompanyDetailsForm";
import MyPosts from "./Components/Company/MyPosts";
import CreatePost from "./Components/Company/CreatePost";
import ApplyPost from "./Components/Body/ApplyPost";
import UpdatePost from "./Components/Company/UpdatePost";
import AllPosts from "./Components/Body/AllPosts";
import AppliedUsers from "./Components/Company/AppliedUsers";
import AppliedUserDetails from "./Components/Company/AppliedUserDetails";
import UpdateUserDetailsForm from "./Components/User/UpdateUserDetailsForm";
import SearchPosts from "./Components/Body/SearchPosts";
import CompanyProfile from "./Components/Company/CompanyProfile";
import UpdateCompanyDetailsForm from "./Components/Company/UpdateCompanyDetailsForm";
import MyAppliedPosts from "./Components/User/MyAppliedPosts";
import Contact from "./Components/Body/Contact";
import LanguageSelector from "./Components/User/LanguageSelector";
import UpdateUserInfo from "./Components/User/UpdateUserInfo";
import UpdateCompanyInfo from "./Components/Company/UpdateCompanyInfo";
import OtherPosts from "./Pages/Admin/CreateOtherPosting/OtherPosts";
import CreateOtherPost from "./Pages/Admin/CreateOtherPosting/CreateOtherPost";
import ForgotPassword from "./Components/Auth/ForgotPassword";
import TermsAndPrivacy from "./Components/Body/TermsAndPrivacy";
import UpdateOtherPost from "./Pages/Admin/CreateOtherPosting/UpdateOtherPost";
import CompanyInfo from "./Components/User/CompanyInfo";
import UserDetailsPage from "./Pages/Admin/UserDetailsPage";
import CompanyDetailsPage from "./Pages/Admin/CompanyDetailsPage";
import FastJobPosting from "./Components/Body/FastJobPosting";
import ControlFastPosts from "./Pages/Admin/ControlFastPosts";
import CreateBlog from "./Pages/Admin/Blogs/CreateBlog";
import Blogs from "./Components/Body/Blogs";
import AdminBlogs from "./Pages/Admin/Blogs/AdminBlogs";
import ShowFastJobPost from "./Components/Body/ShowFastJobPost";
import WaitingApproval from "./Components/Body/WaitingApproval";
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import CreateOtherPostLink from "./Pages/Admin/CreateOtherPosting/CreateOtherPostLink";

function App() {

  return (
    <Routes>
      <Route path="/admin/*">
      <Route index element={<AdminDashboard />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="kullanicilar" element={<UserList />} />
      <Route path="kullanici-detay/:id" element={<UserDetailsPage />} />
      <Route path="firma-detay/:id" element={<CompanyDetailsPage />} />
      <Route path="firmalar" element={<CompanyList />} />
      <Route path="other-posts" element={<OtherPosts />} />
      <Route path="updateOtherPost/:postId" element={<UpdateOtherPost />} />
      <Route path="create-other-post" element={<CreateOtherPost />} />
      <Route path="create-other-post-link" element={<CreateOtherPostLink />} />
      <Route path="fast-post" element={<ControlFastPosts />} />
      <Route path="create-blog" element={<CreateBlog />} />
      <Route path="admin-blogs" element={<AdminBlogs />} />
      </Route>
      <Route>
      <Route path="/" element={<HomePage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/registerCompany" element={<Register />} />
      <Route path="/auth" element={<Login />} />
      <Route path="/login" element={<UserLogin />} />
      <Route path="/waiting-approval" element={<WaitingApproval />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/fast-job-posting" element={<FastJobPosting />} />
      <Route path="/terms-and-privacy" element={<TermsAndPrivacy />} />
      <Route path="/userprofile" element={<UserProfile />} />
      <Route path="/companyprofile" element={<CompanyProfile />} />
      <Route path="/update-user-info" element={<UpdateUserInfo />} />
      <Route path="/update-company-info" element={<UpdateCompanyInfo />} />
      <Route path="/user-details" element={<UserDetailsForm />} />
      <Route path="/update-user-details" element={<UpdateUserDetailsForm />} />
      <Route path="/company-details" element={<CompanyDetailsForm />} />
      <Route path="/update-company-details" element={<UpdateCompanyDetailsForm />} />
      <Route path="/setpassword" element={<SetPassword />} />
      <Route path="/myposts" element={<MyPosts />} />
      <Route path="/diller" element={<LanguageSelector />} />
      <Route path="/create-post" element={<CreatePost />} />
      <Route path="/apply-post/:id" element={<ApplyPost />} />
      <Route path="/apply-fast-post/:id" element={<ShowFastJobPost />} />
      <Route path="/update-post/:id" element={<UpdatePost />} />
      <Route path="/all-posts" element={<AllPosts />} />
      <Route path="/companyinfo/:id" element={<CompanyInfo />} />
      <Route path="/search-posts/:search_term" element={<SearchPosts />} />
      <Route path="/applied-users/:post_id" element={<AppliedUsers />} />
      <Route path="/applied-user-details/:id" element={<AppliedUserDetails />} />
      <Route path="/my-applied-posts" element={<MyAppliedPosts />} />
      </Route>
    </Routes>
  );
}

export default App;
